import type { ProbationForm, ProbationQuestion } from "../schemas/index.ts";

function numericRatingOptions(question: ProbationQuestion): number[] {
  if (question.questionType !== "RADIO" && question.questionType !== "RATING") return [];

  try {
    const options: unknown = JSON.parse(question.optionsJson ?? "null");
    if (!Array.isArray(options) || options.length === 0) return [];
    const numbers = options.map(Number);
    return numbers.every((option) => Number.isFinite(option) && option > 0)
      ? numbers
      : [];
  } catch {
    return [];
  }
}

/** Score numeric SQE manager questions against their maximum available points. */
export function sqeManagerRatingPercentage(
  questions: ProbationQuestion[],
  answers: ProbationForm["answers"],
): number {
  let earnedPoints = 0;
  let possiblePoints = 0;

  questions.forEach((question, index) => {
    const options = numericRatingOptions(question);
    if (options.length === 0) return;

    possiblePoints += Math.max(...options);
    const rawAnswer = answers[index]?.answer;
    if (typeof rawAnswer !== "string" || rawAnswer.trim() === "") return;
    const selected = Number(rawAnswer);
    if (options.includes(selected)) earnedPoints += selected;
  });

  return possiblePoints === 0 ? 0 : Math.round((earnedPoints / possiblePoints) * 100);
}
